import {
  CANCEL_ONBOARDING,
  CLEAR_ONBOARDING_FORM_BY_ID,
  CLEAR_ONBOARDING_SUBMISSION,
  CREATE_COMPOSITE_INPUT_ELEMENT,
  CREATE_FORM_ACTION_ELEMENT,
  CREATE_FORM_INPUT_ELEMENT,
  CREATE_ONBOARDING_SUBMISSION,
  DELETE_ATTACHED_DOCUMENTS,
  DELETE_COMPOSITE_INPUT_ELEMENT,
  DELETE_FORM_INPUT_ELEMENT,
  DELETE_ONBOARDING,
  EDIT_COMPOSITE_INPUT_ELEMENT,
  EDIT_FORM_INPUT_ELEMENT,
  GET_DIRECTORY,
  GET_ONBOARDING_ALL,
  GET_ONBOARDING_BY_ID,
  GET_ONBOARDING_FORM_BY_ID,
  GET_ONBOARDING_FORMS,
  GET_ONBOARDING_TEMPLATES,
  START_ONBOARDING_EDIT,
  STOP_ONBOARDING_EDIT,
  SUBMIT_ONBOARDING,
  UPDATE_ONBOARDING_SUBMISSION,
  UPLOAD_ONBOARDING_DOCUMENT,
} from './onboardingActionTypes';

export const getOnboardingAll = (userId) => ({
  type: GET_ONBOARDING_ALL.ACTION,
  payload: userId,
});

export const getOnboardingById = (data) => ({
  type: GET_ONBOARDING_BY_ID.ACTION,
  payload: data,
});

export const deleteOnboarding = (id) => ({
  type: DELETE_ONBOARDING.ACTION,
  payload: id,
});

export const getOnboardingForms = (path) => ({
  type: GET_ONBOARDING_FORMS.ACTION,
  payload: path,
});

export const getOnboardingTemplates = (path) => ({
  type: GET_ONBOARDING_TEMPLATES.ACTION,
  payload: path,
});

export const getOnboardingFormById = (data) => ({
  type: GET_ONBOARDING_FORM_BY_ID.ACTION,
  payload: data,
});

export const clearOnboardingFormById = () => ({
  type: CLEAR_ONBOARDING_FORM_BY_ID.ACTION,
});

export const clearOnboardingSubmission = () => ({
  type: CLEAR_ONBOARDING_SUBMISSION.ACTION,
});

export const createOnboardingSubmission = (data) => ({
  type: CREATE_ONBOARDING_SUBMISSION.ACTION,
  payload: data,
});

export const updateOnboardingSubmission = (data) => ({
  type: UPDATE_ONBOARDING_SUBMISSION.ACTION,
  payload: data,
});

export const startOnboardingEdit = (id) => ({
  type: START_ONBOARDING_EDIT.ACTION,
  payload: id,
});

export const stopOnboardingEdit = (id) => ({
  type: STOP_ONBOARDING_EDIT.ACTION,
  payload: id,
});

export const deleteAttachedDocuments = (data) => ({
  type: DELETE_ATTACHED_DOCUMENTS.ACTION,
  payload: data,
});

export const createFormInputElement = (data) => ({
  type: CREATE_FORM_INPUT_ELEMENT.ACTION,
  payload: data,
});

export const uploadOnboardingDocument = (data) => ({
  type: UPLOAD_ONBOARDING_DOCUMENT.ACTION,
  payload: data,
});

export const editFormInputElement = (data) => ({
  type: EDIT_FORM_INPUT_ELEMENT.ACTION,
  payload: data,
});

export const deleteFormInputElement = (id) => ({
  type: DELETE_FORM_INPUT_ELEMENT.ACTION,
  payload: id,
});

export const createCompositeInputElement = (data) => ({
  type: CREATE_COMPOSITE_INPUT_ELEMENT.ACTION,
  payload: data,
});

export const editCompositeInputElement = (data) => ({
  type: EDIT_COMPOSITE_INPUT_ELEMENT.ACTION,
  payload: data,
});

export const deleteCompositeInputElement = (id) => ({
  type: DELETE_COMPOSITE_INPUT_ELEMENT.ACTION,
  payload: id,
});

export const createFormActionElement = (data) => ({
  type: CREATE_FORM_ACTION_ELEMENT.ACTION,
  payload: data,
});

export const submitOnboarding = (data) => ({
  type: SUBMIT_ONBOARDING.ACTION,
  payload: data,
});

export const cancelOnboarding = (id) => ({
  type: CANCEL_ONBOARDING.ACTION,
  payload: id,
});

export const getDirectory = (name) => ({
  type: GET_DIRECTORY.ACTION,
  payload: name,
});